<div #container class="container">
    <div class="checkbox-ag-grid">
        <label class="inline">
            <input #trueCheckbox type="checkbox" [checked]="showTrueValues && showFalseValues" (change)="onSelectAllChange($event)">
            <span class="checkbox-ag-grid-label">Select All</span>
        </label>
    </div>
    <hr />
    <div class="checkbox-ag-grid">
        <label class="inline">
            <input #trueCheckbox type="checkbox" [checked]="showTrueValues" (change)="onShowTrueChange($event)">
            <span class="checkbox-ag-grid-label">{{params.trueValueDisplayFormat}}</span>
        </label>
    </div>
    <div class="checkbox-ag-grid">
        <label class="inline">
            <input #falseCheckbox type="checkbox" [checked]="showFalseValues" (change)="onShowFalseChange($event)">
            <span class="checkbox-ag-grid-label">{{params.falseValueDisplayFormat}}</span>
        </label>
    </div>
</div>

